import React, { useEffect, useState } from "react";
import { FormSelect, Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Icon from "../sharedComponents/icons/fontawsomeIcons";
import Button from "../sharedComponents/buttons/button";
import Lang from "../../userPreferences/staticWords";
import { getCurrentLangFromRedux, getDir } from "../../algorithms/styleChanges";
import MembersList from "../../algorithms/listsAlogrithms";
import {
  customStyle,
  styleEnd,
  styleStart,
} from "../../algorithms/styleDirection";
import moment from "moment";
import { addAssignmentCommentAPI } from "../../API/store/actions/PresidentialAssignmenty";
import { addSubAssignment } from "../../API/services/SubPersidentalAssignment";
import {
  addSubAssignmentAPI,
  updateSubAssignmentAPI,
} from "../../API/store/actions/SubPresidentalAssignment";
import DateInput from "../sharedComponents/datesInputs/date";

const CreatePresidentialDirective = (props) => {
  const { show, setShow, selectedAssignment, isEdit, onSuccess, members } =
    props;
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errors, setErrors] = useState({});
  const dispatch = useDispatch();
  const userToken = useSelector((state) => state.login.userToken);
  const user = useSelector((state) => state.login.userData);

  const selectedSubAssignment = useSelector(
    (state) => state.assignments.selectedSubAssignment,
  );
  useEffect(() => {
    if (!show) return;

    if (isEdit && selectedSubAssignment) {
      setFormData({
        id: selectedSubAssignment.id,
        subject: selectedSubAssignment.name || "",
        members:
          selectedSubAssignment.member?.map((item) => item.memberId) || [],
        startDate: selectedSubAssignment.startDate
          ? new Date(selectedSubAssignment.startDate)
          : new Date(),
        endDate: selectedSubAssignment.endDate
          ? new Date(selectedSubAssignment.endDate)
          : new Date(),
        attachments: selectedAssignment?.attchment || [], // important
      });
    }
  }, [show, isEdit, selectedSubAssignment]);

  const handleFilesChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      attachments: Array.from(e.target.files),
    }));
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = {};

    if (!formData.subject.trim()) {
      validationErrors.subject = "اسم التوجيه مطلوب";
    }
    if (!formData.startDate) {
      validationErrors.startDate = "تاريخ البدء مطلوب";
    }

    if (!formData.endDate) {
      validationErrors.endDate = "تاريخ الانتهاء مطلوب";
    }

    if (formData.members.length === 0) {
      validationErrors.members = "الجهة المعنية مطلوبة";
    }

    setErrors(validationErrors);

    if (Object.keys(validationErrors).length) return;

    setErrors(validationErrors);

    if (Object.keys(validationErrors).length > 0) {
      return;
    }

    setIsSubmitting(true);

    setIsSubmitting(true);

    try {
      const data = new FormData();

      data.append("taskId", selectedAssignment.id);
      data.append("NameA", formData.subject);
      data.append("NameE", formData.subject); // or another English title
      data.append("StartDate", new Date(formData.startDate).toISOString());
      data.append("EndDate", new Date(formData.endDate).toISOString());

      formData.members.forEach((id) => {
        data.append("TaskMembers", id);
      });

      formData.attachments.forEach((file) => {
        data.append("files", file);
      });

      // formData.append("taskprocedureId", assignment.id);
      if (isEdit) {
        data.append("Id", formData.id);
      }
      const action = isEdit
        ? await updateSubAssignmentAPI(data, userToken)
        : await addSubAssignmentAPI(data, userToken);

      const result = await dispatch(action);

      if (!result.error) {
        onSuccess?.();

        // setTitle("");
        // setResponseDate(new Date());
        // setAttachments([]);

        setErrors({});
        setShow(false);
      }
    } finally {
      setIsSubmitting(false);
    }
  };
  useEffect(() => {
    if (!show) {
      setErrors({});
    }
  }, [show]);
  const [formData, setFormData] = useState({
    id: undefined,
    subject: "",
    members: [],
    startDate: new Date(),
    endDate: new Date(),
    attachments: [],
  });
  return (
    <Modal
      show={show}
      size="xl"
      aria-labelledsby="contained-modal-title-vcenter"
      centered
      {...props}
      style={{ zIndex: 1000000 }}
      backdrop="static"
    >
      <Modal.Header style={{ direction: getDir(getCurrentLangFromRedux()) }}>
        <Modal.Title id="contained-modal-title-vcenter">
          <div className="d-flex align-items-center">
            <div
              style={{
                backgroundColor: "white",
                height: 25,
                width: 30,
                borderRadius: "50%",
              }}
              className="d-flex justify-content-center text-center align-items-center px-1 mt-1"
            >
              <img
                src={"/assets/policy-green.svg"}
                width={25}
                height={25}
                alt=""
              />
            </div>{" "}
            <div className="text-dark">
              <p
                className="my-0 mx-1"
                style={{
                  fontSize: 18,
                  textAlign: "justify",
                  color: "rgb(12, 87, 76)",
                }}
              >
                {!isEdit ? "إضافة توجيه رئاسي" : "تعديل توجيه رئاسي"}
              </p>
            </div>
          </div>
        </Modal.Title>{" "}
        <div className={`d-flex justify-content-end mt-2 ${styleEnd("m", 3)}`}>
          <Icon
            name="times"
            size={22}
            color={"rgb(12, 87, 76)"}
            onclick={() => setShow(false)}
          />
        </div>
      </Modal.Header>
      <Modal.Body style={{ direction: getDir(getCurrentLangFromRedux()) }}>
        <form onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-12 mb-3">
              <label className="form-label">
                اسم التوجيه <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className={`form-control ${errors.subject ? "is-invalid" : ""}`}
                placeholder="أدخل اسم التوجيه"
                value={formData.subject}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    subject: e.target.value,
                  }))
                }
              />
              {errors.subject && (
                <div className="invalid-feedback">{errors.subject}</div>
              )}
            </div>

            <div className="col-12 mb-3">
              <label className="form-label">
                الجهة المعنية <span className="text-danger">*</span>
              </label>

              <MembersList
                containerStyle="d-flex flex-column mb-4 col-12"
                aboveTitleStyle={`d-flex px-3 col-12 mb-3 ${styleStart("m", 2)}`}
                cardStyle={`d-flex flex-column col-12 py-2 mx-1 ${customStyle("TitleCard")}`}
                cardTitle={Lang.adminMembers}
                list={members}
                id="A"
                checked
                values={formData.members}
                onChange={(e) => {
                  const memberId = Number(e.target.value);

                  setFormData((prev) => ({
                    ...prev,
                    members: e.target.checked
                      ? [...prev.members, memberId]
                      : prev.members.filter((id) => id !== memberId),
                  }));

                  if (errors.members) {
                    setErrors((prev) => ({ ...prev, members: "" }));
                  }
                }}
              />

              {errors.members && (
                <div className="text-danger mt-1">{errors.members}</div>
              )}
            </div>

            {/* Start Date */}
            <div className="col-12 col-md-6 mb-3">
              <label className="form-label">تاريخ البدء</label>
              <DateInput
                inputStyle={"upperZIndex"}
                placeholder={Lang.form}
                containerStyle={`col-12 col-xl-11 ${styleStart("m", 3, "xl")}`}
                iconPrefix="far"
                iconName="calendar"
                value={formData.startDate}
                onChange={(date) => {
                  setFormData((prev) => ({
                    ...prev,
                    startDate: date,
                  }));

                  if (errors.startDate) {
                    setErrors((prev) => ({ ...prev, startDate: "" }));
                  }
                }}
                iconSize={22}
              />
              {errors.startDate && (
                <div className="text-danger mt-1">{errors.startDate}</div>
              )}
            </div>
            {/* End Date */}
            <div className="col-12 col-md-6 mb-3">
              <label className="form-label">تاريخ الانتهاء</label>

              <DateInput
                inputStyle={"upperZIndex"}
                placeholder={Lang.form}
                containerStyle={`col-12 col-xl-11 ${styleStart("m", 3, "xl")}`}
                iconPrefix="far"
                iconName="calendar"
                value={formData.endDate}
                onChange={(date) => {
                  setFormData((prev) => ({
                    ...prev,
                    endDate: date,
                  }));

                  if (errors.endDate) {
                    setErrors((prev) => ({ ...prev, endDate: "" }));
                  }
                }}
                iconSize={22}
              />
              {errors.endDate && (
                <div className="text-danger mt-1">{errors.endDate}</div>
              )}
            </div>
          </div>{" "}
          <div className="col-12 mb-4">
            <label className="form-label">المرفقات</label>
            <input
              type="file"
              className="form-control"
              multiple
              onChange={handleFilesChange}
            />{" "}
          </div>
          <div className="d-flex justify-content-center mt-4">
            <Button
              type="submit"
              disable={isSubmitting}
              buttonStyleType="solid"
              content={isSubmitting ? Lang.isSaving : Lang.save}
              containerStyle="col-2 mx-3"
            />

            <Button
              type="button"
              onClick={() => setShow(false)}
              content={Lang.cancel}
              containerStyle="col-2 mx-3"
            />
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default CreatePresidentialDirective;
